/* src/app/svf/components/modals/inventory-balance-modal/inventory-balance-modal.component.scss */
:host {
  display: block;
}
.min-w-0 {
  min-width: 0;
}
.inventory-summary-value {
  font-size: 1.5rem;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  line-height: 1.2;
}
.inventory-balance-total-avatar {
  background-color: color-mix(in srgb, var(--brand-primary) 20%, transparent);
  color: var(--brand-primary);
}
.inventory-balance-high-avatar {
  background-color: color-mix(in srgb, var(--brand-success) 20%, transparent);
  color: var(--brand-success);
}
.inventory-balance-medium-avatar {
  background-color: color-mix(in srgb, var(--brand-warning) 20%, transparent);
  color: var(--brand-warning);
}
.inventory-balance-low-avatar {
  background-color: color-mix(in srgb, var(--brand-danger) 20%, transparent);
  color: var(--brand-danger);
}
.inventory-clear-filter {
  min-height: 2.5rem;
  white-space: nowrap;
}
.inventory-table-wrapper {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-color: color-mix(in srgb, var(--brand-primary) 30%, transparent) transparent;
}
.inventory-table-wrapper:focus-visible {
  outline: 2px solid var(--brand-primary);
  outline-offset: 2px;
}
.inventory-article-name {
  min-width: 22rem;
  max-width: 30rem;
  overflow-wrap: anywhere;
}
.inventory-item-id {
  width: 12rem;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.inventory-stock {
  width: 9rem;
  text-align: end;
}
.inventory-stock-value {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
:host ::ng-deep .p-datatable-tbody > tr > td {
  vertical-align: middle;
}
:host ::ng-deep .inventory-paginator {
  margin-top: 0.75rem;
}
@media (pointer: coarse) {
  #inventory-search {
    font-size: 1rem;
  }
  .inventory-clear-filter {
    min-height: 2.75rem;
    touch-action: manipulation;
    user-select: none;
    -webkit-user-select: none;
  }
}
/*# sourceMappingURL=inventory-balance-modal.component.css.map */
